import { createAction } from 'redux-actions';
import { getMultipleElementsFromCache } from 'store/actions/element-cache-actions';
import { selectMultipleElementsContentPanel } from 'store/actions/action-creators';

import { showBatchPanelAction } from 'store/actions/panel-controller-actions';
import { RIGHT_PANELS } from 'constants/feature/panel-constants';

import { batchMaxAmountNotification } from 'utils/batch-panel-utils';
import { getMaxElementForBatchUpdateLimit } from 'utils/statement-content-page-utils';

export const addElementToBatchSelectionAction = createAction(
  'BATCH_ADD_ELEMENT_TO',
);
export const setBatchSelectedElementsLoading = createAction(
  'BATCH_ELEMENTS_LOADING',
);
export const appendBatchSelectedElementsLoaded = createAction(
  'BATCH_APPEND_ELEMENTS_LOADED',
);
export const _handleBatchAddWithElementAlreadySelected =
  () => (dispatch, getState) => {
    const {
      ui: {
        statementPage: {
          panels: { right },
        },
      },
      data: {
        statementContent: { elementCache },
        elementPanel: { elementDetails },
      },
    } = getState();
    if (right === RIGHT_PANELS.ELEMENT) {
      // with element panel open + batch click, switch to batch panel with that element selected
      let element =
        elementDetails &&
        // getElement method inside section-cache model mandatorily needs elementID to get element details.
        // if sectionId is null then it will search in all the sections present in the cache.
        elementDetails.id &&
        elementCache.getElement({
          elementId: elementDetails.id,
          sectionId: elementDetails.sectionId,
        });
      element &&
        dispatch(
          addElementToBatchSelectionAction({
            element,
          }),
        );
    }
  };

export const batchAddElementsToBatch =
  ({ elements }) =>
  async (dispatch, getState) => {
    const {
      data: {
        batchPanel: {
          batchElementList: { selectedElementIds },
        },
      },
      ui: {
        statementPage: {
          panels: { right },
        },
      },
    } = getState();
    if (selectedElementIds.length + 1 <= getMaxElementForBatchUpdateLimit()) {
      dispatch(_handleBatchAddWithElementAlreadySelected());
    }
    if (
      selectedElementIds.length + elements.length <=
      getMaxElementForBatchUpdateLimit()
    ) {
      // always select all the elements in the content panel
      dispatch(
        selectMultipleElementsContentPanel({
          elementIds: elements.map((el) => el.elementId),
        }),
      );
      if (!right !== RIGHT_PANELS.BATCH) {
        dispatch(showBatchPanelAction());
      }
      const selectedElements = await dispatch(
        getMultipleElementsFromCache({
          elements,
          loadingAction: setBatchSelectedElementsLoading,
        }),
      );
      dispatch(appendBatchSelectedElementsLoaded({ selectedElements }));
    } else {
      batchMaxAmountNotification();
    }
  };
